module.exports = __webpack_public_path__ + "static/media/small_bacth.cf0b3363.jpg";